// extracted by mini-css-extract-plugin
export default {"root":"PrevioslyUnacceptedInfo_root__vRAZf","placeHolderShimmer":"PrevioslyUnacceptedInfo_placeHolderShimmer__4Rebp"};